export const isSafeRelativePath = (path: string) => /^\/(?![/\\])/.test(path)
